<template>
    <div :class="classes">
        <KEyebrow v-if="$slots.label || label">
            <slot name="label">
                {{ label }}
            </slot>
        </KEyebrow>

        <ul :class="element('list')">
            <li
                v-for="(item, index) in items"
                :key="index"
                :class="element('item')"
            >
                <span
                    :class="element('marker')"
                    aria-hidden="true"
                >
                    <slot
                        name="marker"
                        :variant="variant"
                    >
                        <svg
                            v-if="variant === 'included'"
                            viewBox="0 0 16 16"
                            fill="none"
                            focusable="false"
                        >
                            <path
                                d="m3 8 3 3 7-7"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <svg
                            v-else
                            viewBox="0 0 16 16"
                            fill="none"
                            focusable="false"
                        >
                            <path
                                d="m4 4 8 8m0-8-8 8"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                        </svg>
                    </slot>
                </span>

                <span :class="element('text')">
                    <slot
                        name="item"
                        :item="item"
                        :index="index"
                    >
                        {{ item }}
                    </slot>
                </span>
            </li>
        </ul>

        <div
            v-if="$slots.default"
            :class="element('footer')"
        >
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { KChecklistProps } from './types'
import useBem from '@yeeroen/use-bem'

import { computed } from 'vue'
import KEyebrow from '../eyebrow/k-eyebrow.vue'

defineOptions({ name: 'KChecklist' })

const props = withDefaults(defineProps<KChecklistProps>(), {
    items: () => [],
    variant: 'included',
    size: 'md',
})

defineSlots<{
    default?: () => unknown
    label?: () => unknown
    marker?: (props: { variant: 'included' | 'excluded' }) => unknown
    item?: (props: { item: string, index: number }) => unknown
}>()

const { block, element, modifier } = useBem('k-checklist')

const classes = computed(() => block(
    modifier(props.variant),
    modifier(props.size),
))
</script>

<style lang="scss">
@use './k-checklist.scss';
</style>
